import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";
import farmer1 from "../assets/farmer1.jpg";
import farmer2 from "../assets/farmer2.jpg";
import farmer3 from "../assets/farmer3.jpg";
import "../style/Home.css";

export default function Home() {
  const images = [farmer1, farmer2, farmer3];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="home-container">
      {/* Header */}
      <header className="header">
        <div className="logo-container">
          <img href="/" src={logo} alt="SOLAR SARATHI Logo" className="logo" />
        </div>
        <a href="#contact" className="contact-link">संपर्क करा</a>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <h2>शेतकऱ्यांचा सौर साथी 🌞</h2>
        <div className="slider">
          <img
            src={images[currentIndex]}
            alt="Solar Pump"
            className="slider-image"
          />
          <button
            className="prev"
            onClick={() =>
              setCurrentIndex(
                (currentIndex - 1 + images.length) % images.length
              )
            }
          >
            ❮
          </button>
          <button
            className="next"
            onClick={() => setCurrentIndex((currentIndex + 1) % images.length)}
          >
            ❯
          </button>
        </div>
        <p>
          विजेच्या त्रासातून मुक्त व्हा! सोलर पंपच्या मदतीने शेतसिंचन करा —
          खर्च वाचवा, निसर्ग जपा आणि टिकाऊ शेतीकडे पाऊल टाका.
        </p>
        <a href="#contact" className="cta-btn">
          मोफत सल्ला घ्या
        </a>
      </section>

      {/* Services Section */}
      <section className="services">
        <h3>आमच्या सेवा</h3>
        <div className="service-grid">
          <div className="service-item">
            <h4>🔧 सोलर पंप बसवणी</h4>
            <p>प्रशिक्षित तंत्रज्ञांकडून जलद आणि सुरक्षित बसवणी सेवा.</p>
          </div>
          <div className="service-item">
            <h4>⚙️ देखभाल आणि सेवा</h4>
            <p>वार्षिक देखभाल करार (AMC) व दुरुस्ती सेवा.</p>
          </div>
          <div className="service-item">
            <h4>📄 शासकीय अनुदान मार्गदर्शन</h4>
            <p>पीएम-कुसुम व इतर योजनांसाठी तज्ञ मार्गदर्शन.</p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits">
        <h3>सौर पंपचे फायदे</h3>
        <ul>
          <li>वीजेवर अवलंबित्व नाही</li>
          <li>डिझेल खर्च शून्य</li>
          <li>पर्यावरणपूरक उपाय</li>
          <li>सरकारी अनुदान उपलब्ध</li>
          <li>कमी देखभाल खर्च</li>
          <li>दीर्घकाळ टिकणारी कार्यक्षमता</li>
        </ul>
      </section>

      <section id="contact" className="contact">
        <h3>संपर्क करा</h3>
        <p>तुमच्या शेतासाठी योग्य सौर उपाय जाणून घेण्यासाठी आमच्याशी संपर्क साधा.</p>
        <form
          className="contact-form"
          onSubmit={(e) => {
            e.preventDefault();

            const name = e.target[0].value.trim();
            const phone = e.target[1].value.trim();
            const message = e.target[2].value.trim();

            const companyNumber = "919922777479";

            const text = `*सोलार सारथी साईट वरून चौकशी केली*\n\n नाव: ${name}\n मोबाईल: ${phone}\n संदेश: ${message}\n\nकृपया माझ्याशी संपर्क साधा.`;

            const encodedText = encodeURIComponent(text);
            const whatsappURL = `whatsapp://send?phone=${companyNumber}&text=${encodedText}`;
            const webURL = `https://wa.me/${companyNumber}?text=${encodedText}`;

            window.location.href = whatsappURL;

            setTimeout(() => {
              window.open(webURL, "_blank");
            }, 1000);
          }}
        >
          <input type="text" placeholder="नाव" required />
          <input type="tel" placeholder="मोबाईल नंबर" required />
          <textarea placeholder="तुमची माहिती / चौकशी" rows="4"></textarea>
          <button type="submit">सबमिट करा</button>
        </form>
        <div className="contact-info">
          <p>📞 फोन: +91 9922777479</p>
          <p>📍 ठिकाण: कृष्णा इंटरप्रायजेस, मामा चौक, वसमत, जिल्हा हिंगोली - 431512</p>
          <p>📧 ईमेल: info@solarsarathi.com</p>
        </div>
      </section>

      <footer className="footer">
        <p>© 2025 SOLAR SARATHI | सर्व हक्क राखीव</p>
      </footer>
    </div>
  );
}
